import Image from "next/image";
import NotFound from "@/app/assets/common/NotFound.png";

export type TableEmptyProps = {
  img?: any;
  title?: string;
  sub?: string;
  container?: string;
};

export const PageResult: React.FC<TableEmptyProps> = ({
  img = NotFound,
  title = "Sorry, the page is lost",
  sub = "Try refreshing it again.",
  ...props
}) => {
  return (
    <div className="items-center flex flex-col justify-center">
      <div className="flex justify-center">
        <div className={props?.container ?? "w-170 lg:w-180"}>
          <Image
            src={img}
            width={100}
            height={100}
            sizes="100vw"
            className="h-auto w-full"
            alt={"result-image"}
          />
        </div>
      </div>
      <h1 className="text-center leading-20 text-13 text-[#ffffff50]">
        {title}
      </h1>
      <h3 className="mt-4 text-center leading-22 text-bravve-sub-100">{sub}</h3>
    </div>
  );
};
